<div class="cm-radio-group" [class.cm-disabled]="$disabled()">
    <ng-content></ng-content>
</div>
